function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,0)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 853 111 L 740 111 L 740 0 L 666 0 L 666 222 L 592 222 L 592 111 L 333 111 L 333 0 L 259 0 L 259 222 L 185 222 L 185 111 L 111 111 C 50 111 0 160 0 222 L 0 888 C 0 949 50 1000 111 1000 L 853 1000 C 914 1000 962 949 962 888 L 962 222 C 962 160 914 111 853 111 z M 851 888 L 111 888 L 111 370 L 851 370 L 851 888 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.f90b13bdc801c09e47310c2c15870215.svg";
export { ForwardRef as ReactComponent };